import React from "react";
import _ from "lodash";
import ButtonBar from "../base/ButtonBar";
import Button from "../base/Button";
import Panel from "../base/Panel";
import PanelContent from "../base/PanelContent";
import PropertyInput from "../PropertyInput";
import DomainSettingsActions from "../../actions/DomainSettingsActions";
import uiPrefix from "../../utils/UiPrefixUtils";

class DomainPanel extends React.Component {
  constructor(props) {
    super(props);

    this._onDomainPrefixChange = this._onDomainPrefixChange.bind(this);
    this._save = this._save.bind(this);
    this._cancel = this._cancel.bind(this);
  }

  _onDomainPrefixChange(propChange) {
    propChange.value = propChange.value == true ? 1 : 0;

    DomainSettingsActions.updateProperty(propChange);
  }

  _save() {
    DomainSettingsActions.saveSettings();
  }

  _cancel() {
    DomainSettingsActions.undoSettingsChange();
  }

  render() {
    var { domainSettings } = this.props;
    var domain = domainSettings.getIn(["current"]);
    var changed = domainSettings.getIn(["changed"]);

    var domainName = domain.get("domain_name", "Unknown");
    var wwwRequired = domain.get("www_required", false) == 1;

    var primaryLabel = "Close";
    var primaryAction = this.props.onClose;

    if (changed) {
      primaryLabel = "Save";
      primaryAction = this._save;
    }

    return (
      <Panel style={{ padding: 15 }}>
        <PanelContent>
          <PropertyInput
            type="checkbox"
            propName="www_required"
            checked={wwwRequired}
            label="Use www"
            onChange={this._onDomainPrefixChange}
          />
          <p className="instrux">
            Your canonical url will be: {(wwwRequired ? "www." : "") + domainName}
          </p>
        </PanelContent>

        <ButtonBar>
          {changed ? (
            <Button
              look="link"
              data-e2e={uiPrefix("modal-cancel-btn")}
              lassName={uiPrefix("modal-cancel-btn")}
              onClick={this._cancel}
            >
              Cancel
            </Button>
          ) : null}
          <Button
            look="primary"
            data-e2e={uiPrefix("modal-action-btn")}
            className={uiPrefix("modal-action-btn")}
            onClick={primaryAction}
          >
            {primaryLabel}
          </Button>
        </ButtonBar>
      </Panel>
    );
  }
}

export default DomainPanel;
